<template>
    <div class="app">
        <el-dialog :title="title" v-if="DialogVisible1" :visible.sync="DialogVisible1" width="80%"
            :modal-append-to-body='true' :append-to-body="true">
            <el-form :inline="true" :model="obj" class="demo-form-inline" size="mini">
                <el-form-item :label="item.label" v-for="(item, index) in formlist" :key="index">
                    <!-- 开始时间 -->
                    <el-date-picker v-if="item.prop == 'start'" size="mini" v-model="obj[item.prop]"
                        format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                    <!-- 结束时间 -->
                    <el-date-picker v-else-if="item.prop == 'end'" @change="changeTime" size="mini" v-model="obj[item.prop]"
                        format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
                    <!-- 检索方案 -->
                    <el-input v-else-if="item.fieldType == 'search'" clearable v-model="obj[item.prop]"
                        @keyup.enter.native="openSearch(item.searchId, index, item.prop, item.setField)">
                        <el-button @click="openSearch(item.searchId, index, item.prop, item.setField)" slot="append"
                            icon="el-icon-search"></el-button>
                    </el-input>
                    <el-input v-else v-model.trim="obj[item.prop]" size="mini"
                        :maxlength="$store.state.inputLength"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="table">
                <el-table stripe :data="data.list" height="420" border style="width: 100%" highlight-current-row
                    size="mini">
                    <!-- 采购订单主表格 -->
                    <el-table-column v-for="(tableValye, tableKey) in data.name" :key="tableKey" show-overflow-tooltip
                        :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                                {{ scope.row.isWms == 0 ? '否' : '是' }}
                            </el-tag>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row.psomState) }}</el-tag>
                            <span v-else-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                                }}</a>
                            </span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page_content_bottom">
                <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber"
                    :current-page="obj.page" :page-sizes="[30, 50, 100, 500]" :page-size="obj.rows"
                    layout="total, sizes, prev, pager, next, jumper" :total="data.obj.total">
                </el-pagination>
            </div>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="searchId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" />
        </el-dialog>
    </div>
</template>
  
<script>
import historicalList from "@/byComponents/historicalOrders/historicalList";
export default {
    name: "historicalSalesOrder",
    data() {
        return {
            title: "",
            seWidth: "",
            formlist: [],
            data: {
                list: [],
                name: [],
                obj: {
                    total: 10
                }
            },
            DialogVisible1: false,
            DialogVisible: false,//检索方案
            searchId: "",//检索Id
            setField: "",//赋值字段组（字符串格式）
            entityField: "",//字段名称
            seTitle: "",
            obj: {
                smName: "",
                smId: "",
                cmName: "",
                cmId: "",
                bgmName: "",
                bgmId: "",
                start: this.$common.getStartTime(),
                end: this.$common.getEndTime(),
                page: 1,
                rows: 30,
            },
            parentSearchData: {},
        }
    },
    watch: {
        'obj.cmName'() {
            if (this.obj.cmName == "") {
                this.obj.cmId = ""
            }
        },
        'obj.smName'() {
            if (this.obj.smName == "") {
                this.obj.smId = ""
            }
        },
        'obj.bgmName'() {
            if (this.obj.bgmName == "") {
                this.obj.bgmId = ""
            }
        }
    },
    created() {
    },
    methods: {
        openBox(oldData, type) {
            this.title = type
            this.data.name = historicalList.saleProcurelist
            this.formlist = historicalList.salelistObj
            if (oldData) {
                for (const key in oldData) {
                    this.obj[key] = oldData[key]
                }
            }
            this.obj.page = 1
            this.getDataList()
            this.DialogVisible1 = true
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        searchData() {
            this.obj.page = 1
            this.getDataList()
        },
        openSearch(searchId, index, prop, setField) {
            if (prop == 'smName') {
                this.seTitle = "购进单位"
            } else if (prop == 'bgmName') {
                this.seTitle = "品种列表"
                this.parentSearchData[prop] = this.obj[prop]
            }

            this.searchId = searchId
            this.entityField = prop
            this.setField = setField
            this.DialogVisible = true
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.obj.end = time;
            }
        },
        changeInputModel(val) {
            this.paramValue(val)
            this.DialogVisible = false
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.setField.split(",");
            arr.forEach((item) => {
                this.obj[item] = val[item];
            });
        },
        async getDataList() {
            console.log(this.obj);
            const responseData = await this.$http.getqueryHisOutPrice(this.obj)
            if (responseData.status == 200) {
                this.data.list = responseData.result.list
                this.data.obj.total = responseData.result.total
            } else {
                this.$message.error(responseData.message)
            }
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.obj.page = val;
            this.getDataList();
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.obj.page = 1;
            this.obj.rows = val;
            this.getDataList();
        },
    },
}
</script>
  
<style scoped></style>